export default __webpack_public_path__ + "static/media/youtube_icon.37f6656f.svg";